var map = {
	"./1.png": 68,
	"./10.jpg": 24,
	"./11.png": 25,
	"./2.png": 69,
	"./3.png": 70,
	"./4.png": 71,
	"./5.png": 72,
	"./6.png": 73,
	"./7.png": 74,
	"./8.png": 75,
	"./9.png": 76,
	"./Backgound with gradients.png": 77,
	"./Image-1.png": 78,
	"./Image-2.png": 79,
	"./Image-3.png": 80,
	"./Image-4.png": 81,
	"./Image-5.png": 82,
	"./Image-6.png": 41,
	"./Image-7.png": 83,
	"./Image.png": 84,
	"./Short Details Card 1.png": 85,
	"./Short Details Card 2.png": 86,
	"./avatar.png": 9,
	"./avatar_3.png": 87,
	"./avatar_4.png": 88,
	"./avatar_5.png": 89,
	"./avatrar_2.png": 90,
	"./bg.png": 91,
	"./footer bg.png": 92
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 40;